import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const names = ['Lucía', 'Martina', 'Valentina', 'Sofía', 'Camila', 'Agustina', 'Florencia', 'Rocío', 'Julia', 'Paula', 'Tomás', 'Matías', 'Nicolás', 'Santiago', 'Facundo', 'Ignacio', 'Joaquín', 'Ezequiel', 'Bruno', 'Leandro'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'La Plata', 'Mendoza', 'Mar del Plata', 'Tucumán', 'Salta', 'Santa Fe', 'San Juan'];
const packs = ['Pack Esencial — Aprobá en serio', 'Pack Total — Aprobá en serio', 'Pack Total — Aprobá en serio' // Double frequency
];
export function RecentPurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseData, setPurchaseData] = useState({
    name: '',
    city: '',
    pack: ''
  });
  useEffect(() => {
    // Initial delay of 8 seconds
    const initialTimer = setTimeout(() => {
      scheduleNextPopup();
    }, 8000);
    return () => clearTimeout(initialTimer);
  }, []);
  const scheduleNextPopup = () => {
    // Random delay between 30 and 60 seconds
    const delay = Math.floor(Math.random() * (60000 - 30000 + 1)) + 30000;
    setTimeout(() => {
      showPopup();
    }, delay);
  };
  const showPopup = () => {
    // Generate random data
    const randomName = names[Math.floor(Math.random() * names.length)];
    const randomCity = cities[Math.floor(Math.random() * cities.length)];
    const randomPack = packs[Math.floor(Math.random() * packs.length)];
    setPurchaseData({
      name: randomName,
      city: randomCity,
      pack: randomPack
    });
    setIsVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
      scheduleNextPopup(); // Schedule the next one after this one hides
    }, 5000);
  };
  return <AnimatePresence data-id="element-182">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="fixed bottom-4 left-4 z-50 w-[85%] max-w-[320px] bg-white rounded-xl shadow-lg border-l-4 border-l-salmon p-4 flex items-start gap-3" style={{
      borderRadius: '12px'
    }} data-id="element-183">
          <div className="bg-peach/30 p-2 rounded-full shrink-0 mt-1" data-id="element-184">
            <ShoppingBag size={20} className="text-orange-600" data-id="element-185" />
          </div>

          <div className="flex-grow pr-4" data-id="element-186">
            <p className="text-sm text-dark leading-tight mb-0.5" data-id="element-187">
              <span className="font-bold" data-id="element-188">{purchaseData.name}</span> de{' '}
              <span className="font-bold" data-id="element-189">{purchaseData.city}</span>
            </p>
            <p className="text-xs text-dark/80 leading-tight mb-1" data-id="element-190">
              acaba de comprar{' '}
              <span className="font-semibold" data-id="element-191">{purchaseData.pack}</span>
            </p>
            <p className="text-[10px] text-dark/40 font-medium" data-id="element-192">
              Hace un momento
            </p>
          </div>

          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-dark/30 hover:text-dark/60 transition-colors" aria-label="Cerrar notificación" data-id="element-193">
            <X size={14} data-id="element-194" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}